export default "__VITE_ASSET__CcL03LhM__"